import React from "react";

import AscendingIcon from "../../../../assets/sortAscending.svg";
import DescendingIcon from "../../../../assets/sortDescending.svg";

export const ASCENDING = "ascending";
export const DESCENDING = "descending";
interface SortProps {
  selectedButton: string;
  handleSortClick: (_order: "ascending" | "descending" | "") => void;
}

export const Sort: React.FC<SortProps> = ({ selectedButton, handleSortClick }) => {
  return (
    <div className="selection_container ascDesc_filter">
      <button
        className="sort_btn descending"
        style={{
          color: selectedButton === DESCENDING ? "green" : "black",
          border: selectedButton === DESCENDING ? "1px solid green" : "",
          backgroundColor: selectedButton === DESCENDING ? "#F2F7E9" : "transparent",
        }}
        onClick={() => {
          handleSortClick(selectedButton === DESCENDING ? "" : DESCENDING);
        }}
      >
        <img
          src={DescendingIcon}
          alt="Descending Icon"
          style={{
            filter:
              selectedButton === DESCENDING
                ? "invert(34%) sepia(95%) saturate(749%) hue-rotate(82deg)"
                : "",
          }}
        />
        <p>Descending</p>
      </button>
      <button
        className="sort_btn ascending"
        style={{
          color: selectedButton === ASCENDING ? "green" : "black",
          border: selectedButton === ASCENDING ? "1px solid green" : "",
          backgroundColor: selectedButton === ASCENDING ? "#F2F7E9" : "transparent",
        }}
        onClick={() => {
          handleSortClick(selectedButton === ASCENDING ? "" : ASCENDING);
        }}
      >
        <img
          src={AscendingIcon}
          alt="Ascending Icon"
          style={{
            filter:
              selectedButton === ASCENDING
                ? "invert(34%) sepia(95%) saturate(749%) hue-rotate(82deg)"
                : "",
          }}
        />
        <p>Ascending</p>
      </button>
    </div>
  );
};
